/* wb-product-reviews-lightbox.js — la visionneuse des photos d'avis de fiche.
   Copie de référence du dépôt parent : l'original déployé est
   `assets/wb-product-reviews-lightbox.js` du thème live (en cas de doute le thème live
   fait foi). Sortie de `assets/wb-product-reviews.js` le 01/10/2026, telle quelle, pour
   n'être chargée que sur une fiche qui a des photos d'avis : la section ne rend le
   `<dialog data-wb-lightbox>` et ne charge ce fichier qu'à cette condition, juste avant
   `wb-product-reviews.js`, qui l'appelle (`bind` à l'amorçage, `open` au clic).

   Sans ce fichier, un clic sur une vignette ouvre la photo dans un onglet. */
window.WBReviewsLightbox = (function () {
  'use strict';

  var PHOTO_SELECTOR = '.wb-review__photo';
  var LIGHTBOX_SELECTOR = '[data-wb-lightbox]';
  var viewer = null;
  var config = { toText: function (html) { return String(html || ''); }, listSelector: '' };

  /* Les photos parcourues par les flèches : celles de la galerie, ou celles du
     même avis. */
  function photoSet(block, button) {
    var set = button.getAttribute('data-wb-photo-set');
    var scope = set ? block : (button.closest('.wb-review') || button.parentNode);
    return Array.prototype.filter.call(scope.querySelectorAll(PHOTO_SELECTOR), function (el) {
      return (el.getAttribute('data-wb-photo-set') || '') === (set || '');
    });
  }

  /* La légende : l'avis de la photo. La galerie la porte en `data-*` (ses avis ne
     sont pas forcément dans la liste), une vignette d'avis la lit dans son avis. */
  function captionFor(button) {
    if (button.hasAttribute('data-wb-photo-name')) {
      // `body_html` brut : décodé ici comme pour la liste (Liquid n'a pas de filtre
      // qui décode les entités, `strip_html` laisserait « &amp; »).
      return {
        name: button.getAttribute('data-wb-photo-name'),
        rating: button.getAttribute('data-wb-photo-rating'),
        body: config.toText(button.getAttribute('data-wb-photo-body-html') || ''),
      };
    }
    var review = button.closest('.wb-review');
    if (!review) return { name: '', rating: '', body: '' };
    var stars = review.querySelector('.wb-reviews__stars');
    var body = review.querySelector('.wb-review__body');
    return {
      name: (review.querySelector('.wb-review__name') || {}).textContent || '',
      rating: stars ? stars.style.getPropertyValue('--wb-rating').trim() : '',
      body: body ? body.textContent : '',
    };
  }

  function renderCaption(el, caption) {
    while (el.firstChild) el.removeChild(el.firstChild);
    var name = document.createElement('strong');
    name.className = 'wb-reviews__lightbox-name';
    name.textContent = caption.name;
    el.appendChild(name);
    if (caption.rating) {
      var stars = document.createElement('span');
      stars.className = 'wb-reviews__stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.style.setProperty('--wb-rating', String(Number(caption.rating) || 0));
      el.appendChild(stars);
    }
    if (caption.body) {
      var body = document.createElement('p');
      body.className = 'wb-reviews__lightbox-body';
      body.textContent = caption.body;
      el.appendChild(body);
    }
  }

  function showPhoto() {
    var button = viewer.set[viewer.index];
    var dialog = viewer.dialog;
    var image = dialog.querySelector('[data-wb-lightbox-image]');
    image.setAttribute('src', button.getAttribute('data-wb-photo'));
    image.setAttribute('alt', button.getAttribute('aria-label') || '');
    renderCaption(dialog.querySelector('[data-wb-lightbox-caption]'), captionFor(button));
    var several = viewer.set.length > 1;
    dialog.querySelector('[data-wb-lightbox-prev]').hidden = !several;
    dialog.querySelector('[data-wb-lightbox-next]').hidden = !several;
  }

  function stepPhoto(delta) {
    if (!viewer || viewer.set.length < 2) return;
    viewer.index = (viewer.index + delta + viewer.set.length) % viewer.set.length;
    showPhoto();
  }

  function openLightbox(block, button) {
    var dialog = block.querySelector(LIGHTBOX_SELECTOR);
    var url = button.getAttribute('data-wb-photo');
    if (!url) return;
    // Sans `<dialog>` modal (navigateur ancien) : la photo dans un onglet.
    if (!dialog || typeof dialog.showModal !== 'function') {
      window.open(url, '_blank', 'noopener');
      return;
    }
    var set = photoSet(block, button);
    viewer = { dialog: dialog, set: set, index: Math.max(0, set.indexOf(button)), opener: button,
      overflow: document.documentElement.style.overflow };
    showPhoto();
    // Un `<dialog>` modal ne bloque pas le défilement de la page derrière.
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
  }

  function bindLightbox(block, options) {
    config = options;
    var dialog = block.querySelector(LIGHTBOX_SELECTOR);
    if (!dialog) return;
    dialog.addEventListener('click', function (event) {
      // Un clic sur le fond (le `<dialog>` lui-même) ferme, comme Échap.
      if (event.target === dialog || event.target.closest('[data-wb-lightbox-close]')) dialog.close();
      else if (event.target.closest('[data-wb-lightbox-prev]')) stepPhoto(-1);
      else if (event.target.closest('[data-wb-lightbox-next]')) stepPhoto(1);
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') stepPhoto(-1);
      else if (event.key === 'ArrowRight') stepPhoto(1);
    });
    dialog.addEventListener('close', function () {
      var opener = viewer && viewer.opener;
      document.documentElement.style.overflow = viewer ? viewer.overflow : '';
      viewer = null;
      // Vignette retirée entre-temps (un tri a remplacé la liste) : la liste.
      if (opener && document.contains(opener)) opener.focus();
      else {
        var list = block.querySelector(config.listSelector);
        if (list) {
          list.setAttribute('tabindex', '-1');
          list.focus({ preventScroll: true });
        }
      }
    });
  }

  /* `options.toText` : le texte d'un `body_html` (celui de la liste) ;
     `options.listSelector` : la liste, qui reprend le focus si la vignette a disparu. */
  return { bind: bindLightbox, open: openLightbox, PHOTO_SELECTOR: PHOTO_SELECTOR, LIGHTBOX_SELECTOR: LIGHTBOX_SELECTOR };
})();
